import { memo } from 'react';

import { Heading, Text } from '@/components/core';
import { ExportHeader, SetupRequired } from '@/components/flow';
import { PowerAutomateLogo } from '@/components/logos';
import { toActionId, useGetAction } from '@/hooks/api';
import { isNotConfiguredExport } from '@/utils';

export type PowerAutomateExportNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IPowerAutomateExportNodeContent = ({ agentId, actionId }: PowerAutomateExportNodeContentProps) => {
  const { data: action } = useGetAction(toActionId(actionId));

  return (
    <>
      <div className="gap-sm pb-sm flex items-center border-b border-gray-200">
        <ExportHeader agentId={agentId} actionId={actionId}>
          <PowerAutomateLogo size="lg" />
          <Heading size="lg">Export to Power Automate</Heading>
        </ExportHeader>
      </div>

      <div className="flex gap-2 pt-2">
        {isNotConfiguredExport(action) ? (
          <SetupRequired />
        ) : (
          <Text className="flex flex-row flex-wrap items-center gap-2">
            Export files to:
            <Text className="flex items-center gap-1 rounded-lg bg-gray-100 px-2 py-1">Power Automate</Text>
          </Text>
        )}
      </div>
    </>
  );
};

export const PowerAutomateExportNodeContent = memo(
  IPowerAutomateExportNodeContent
) as typeof IPowerAutomateExportNodeContent;
